// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Check = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill={fill || 'none'}
      stroke={stroke}
      strokeWidth='2px'
    >
      <circle cx='24' cy='24' r='22' />
      <path d='M20,32.5l17-17s-17,17-17,17Z' />
      <path d='M20,32.5l-9-9,9,9Z' />
    </svg>
  );
};
